import React from 'react';
import $ from 'jquery';
import { useAuth } from '../context/AuthContext';

const Header = () => {
    const { user } = useAuth();

    const toggleFullScreen = () => {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
        } else {
            document.exitFullscreen();
        }
    };

    const changeTheme = () => {
        const currentTheme = localStorage.getItem("app-skin-dark") || "app-skin-light";

        if (currentTheme === "app-skin-dark") {
            $(".dark-button").hide().addClass("active");
            $(".light-button").show().removeClass("active");
            $("html").addClass("app-skin-dark");
        } else {
            $(".light-button").hide().addClass("active"); 
            $(".dark-button").show().removeClass("active");
            $("html").addClass("app-skin-light");
        }
    };

    const handleDarkTheme = (e) => {
        e.preventDefault();
        $(".dark-button").hide().addClass("active");
        $(".light-button").show().removeClass("active");
        $("html").removeClass("app-skin-light");
        $("html").addClass("app-skin-dark");
        localStorage.setItem("app-skin-dark", "app-skin-dark");
    };

    const handleLightTheme = (e) => {
        e.preventDefault();
        $(".light-button").hide().addClass("active");
        $(".dark-button").show().removeClass("active");
        $("html").removeClass("app-skin-dark");
        $("html").addClass("app-skin-light");
        localStorage.setItem("app-skin-dark", "app-skin-light");
    };

    React.useEffect(() => {
        changeTheme();
        $(".dark-button").on("click", handleDarkTheme);
        $(".light-button").on("click", handleLightTheme);
        $("[data-style='reset-app-skin']").on("click", function(e) {
            e.preventDefault();
            localStorage.removeItem("app-skin-dark");
            window.location.reload(true);
        });

        return () => {
            $(".dark-button").off("click", handleDarkTheme);
            $(".light-button").off("click", handleLightTheme);
            $("[data-style='reset-app-skin']").off("click");
        };
    }, []);

    return (
    <header className="nxl-header">
        <div className="header-wrapper">
            <div className="header-left d-flex align-items-center gap-4">
            <a href="javascript:void(0);" className="nxl-head-mobile-toggler" id="mobile-collapse">
                <div className="hamburger hamburger--arrowturn">
                    <div className="hamburger-box">
                        <div className="hamburger-inner"></div>
                    </div>
                </div>
            </a>
            <div className="nxl-navigation-toggle">
                <a href="javascript:void(0);" id="menu-mini-button">
                    <i className="feather-align-left"></i>
                </a>
                <a href="javascript:void(0);" id="menu-expend-button" style={{display: 'none'}}>
                    <i className="feather-arrow-right"></i>
                </a>
            </div>
        </div>
        <div className="header-right ms-auto">
            <div className="d-flex align-items-center">
                <div className="nxl-h-item d-none d-sm-flex">
                    <div className="full-screen-switcher">
                        <a href="javascript:void(0);" className="nxl-head-link me-0" onClick={toggleFullScreen}>
                            <i className="feather-maximize maximize"></i>
                            <i className="feather-minimize minimize"></i>
                        </a>
                    </div>
                </div>
                <div className="nxl-h-item dark-light-theme">
                    <a href="javascript:void(0);" className="nxl-head-link me-0 dark-button" onClick={changeTheme}>
                        <i className="feather-moon"></i>
                    </a>
                    <a href="javascript:void(0);" className="nxl-head-link me-0 light-button" style={{display: 'none'}} onClick={changeTheme}>
                        <i className="feather-sun"></i>
                    </a>
                </div>
                <div className="dropdown nxl-h-item">
                    <a href="javascript:void(0);" data-bs-toggle="dropdown" role="button" data-bs-auto-close="outside">
                        <img src={user.Profil_Gorseli} alt="user-image" className="img-fluid user-avtar me-0" />
                    </a>
                    <div className="dropdown-menu dropdown-menu-end nxl-h-dropdown nxl-user-dropdown">
                        <div className="dropdown-header">
                            <div className="d-flex align-items-center">
                                <img src={user.Profil_Gorseli} alt="user-image" className="img-fluid user-avtar" />
                                <div>
                                    <h6 className="text-dark mb-0">{user.Kullanici_Adi} {user.Kullanici_Soyadi} <span className="badge bg-soft-success text-success ms-1">{user.Kullanici_Yetki == 0 ? "ADMIN" : "TEMSİLCİ"}</span></h6>
                                    <span className="fs-12 fw-medium text-muted">{user.Kullanici_Email}</span>
                                </div>
                            </div>
                        </div>
                        <div className="dropdown-divider"></div>
                        <a href="./my-account" className="dropdown-item">
                            <i className="feather-user"></i>
                            <span>Hesabım</span>
                        </a>
                        <div className="dropdown-divider"></div>
                        <a href="./logout" className="dropdown-item">
                            <i className="feather-log-out"></i>
                            <span>Çıkış Yap</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </header>
    );
};

export default Header;
